import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'
import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'
import { CoreApplicationListComponent } from './core-application-area-list/core-application-area-list.component'

export const coreApplicationAreaRoutes: Route[] = [
  {
    path: 'core-application-areas',
    component: CoreApplicationListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'core-application-areas/:id/edit',
    redirectTo: 'core-application-areas/:id',
    pathMatch: 'full'
  },
  {
    path: 'core-application-areas/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'CoreApplicationArea',
        nameSingular: 'Core Application Area',
        namePlural: 'Core Application Areas',
        path: 'core-application-areas',
        slug: 'taxonomies/core-application-areas',
        title: 'Core Application Areas'
      }),
      permission: 'readTaxonomies'
    }
  }
]
